document.addEventListener('DOMContentLoaded', function () {

  // Matches "250 G", "250g", "1 KG", "1.5kg", also inside "Pack of 2 (50g)"
  var WEIGHT_RE = /(\d+(?:\.\d+)?)\s*(kg|kilogram|g|gram|grams)\b/i;
  // Matches "Pack of 2", "2 pack", "2x" — a multiplier applied to the weight found above
  var PACK_RE = /pack of\s*(\d+)|(\d+)\s*x\b/i;

  function gramsFromText(text) {
    if (!text) return null;
    var wMatch = text.match(WEIGHT_RE);
    if (!wMatch) return null;
    var value = parseFloat(wMatch[1]);
    var unit = wMatch[2].toLowerCase();
    var grams = unit.indexOf('kg') === 0 || unit.indexOf('kilo') === 0 ? value * 1000 : value;

    var pMatch = text.match(PACK_RE);
    if (pMatch) {
      var count = parseInt(pMatch[1] || pMatch[2], 10);
      if (count) grams = grams * count;
    }
    return grams;
  }

  function money(amount) {
    if (isNaN(amount)) return '';
    return '₹' + amount.toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }

  document.querySelectorAll('[data-price-card-weight]').forEach(function (weightEl) {
    var label = weightEl.closest('.opt-label--price-card');
    if (!label) return;

    var perUnitEl = label.querySelector('[data-price-card-per-unit]');
    if (!perUnitEl) return;

    var grams = gramsFromText(weightEl.textContent);
    if (!grams) return;

    // data-price-cents holds the raw Shopify variant.price value, which is
    // already in the shop's smallest currency subunit (e.g. paise for INR).
    var priceCents = parseFloat(perUnitEl.dataset.priceCents);
    if (isNaN(priceCents)) return;

    var pricePerGram = (priceCents / 100) / grams;
    perUnitEl.textContent = '(' + money(pricePerGram) + ' / g)';
    perUnitEl.hidden = false;
  });
});